import { Ref, ref } from 'vue'

export const useStoreEditingDialogs = <T>(dto: Ref<T | undefined>) => {
  const isVisibleEditing = ref(false)
  const isVisibleCreating = ref(false)

  const close = () => {
    isVisibleEditing.value = false
    isVisibleCreating.value = false
    dto.value = undefined
  }

  const openCreating = () => {
    isVisibleCreating.value = true
  }

  const openEditing = (value: T) => {
    dto.value = value
    isVisibleEditing.value = true
  }

  return {
    isVisibleEditing,
    isVisibleCreating,
    close,
    openCreating,
    openEditing,
  }
}
